<div class="quick-uploader-content"
     [class.is-circle]="is_circle || self_avatar"
     [class.empty]="!picture_src"
     [class.hasImage]="!!picture_src">
  <form *ngIf="1" class="quick-uploader-form">
    <span class="message" *ngIf="!picture_src">{{ (self_avatar ? 'drag_your_avatar_here' : 'drag_image_here') | GetLabelPipe}}</span>
    <span class="message" *ngIf="!picture_src">{{ (!is_circle && !self_avatar) ? ('or' | GetLabelPipe) : ' ' }}</span>
    <div class="add-local-button single mat-button">
      <span>{{'pick_image_file' | GetLabelPipe}}</span>
      <input type="file" name="files[]" (change)="handleFileInput($event)" />
    </div>
    <div *ngIf="picture_src && !self_avatar" class="add-local-button single mat-button delete-btn" (click)="deletePicture()">
      <span>{{'delete_image_file' | GetLabelPipe}}</span>
    </div>
  </form>
  <img *ngIf="picture_src" src="{{picture_src}}">
</div>
